import axios from "axios";
import { CancelOrderRequest, ContactUsRequest, DataInquiryRequest, GiftCardRequest } from "../types/type";

const base = process.env.REACT_APP_BASE_URL || "";
const token = process.env.REACT_APP_API_TOKEN || "";

export const API_BASE_URL = `${base}/api`;

export const api = axios.create({ baseURL: API_BASE_URL });

export async function dataInquiryJson(payload: DataInquiryRequest) {
  const res = await api.post("iframe/create-ticket", payload, { headers: { 'x-client-token': `${token}` } });
  return res.data;
}

export async function cancelOrderJson(payload: CancelOrderRequest) {
  const res = await api.post("iframe/cancel-order", payload, { headers: { 'x-client-token': `${token}` } });
  return res.data;
}

export async function contactUsJson(payload: ContactUsRequest) {
  const res = await api.post("iframe/contact-us", payload, { headers: { 'x-client-token': `${token}` } });
  return res.data;
}

export async function giftCardJson(payload: GiftCardRequest) {
  const res = await api.post("iframe/gift-card", payload, { headers: { 'x-client-token': `${token}` } });
  return res.data;
}

export async function lobbyForm(payload: any) {
  const res = await api.post("iframe/lobby-form", payload, { headers: { 'x-client-token': `${token}` } });
  return res.data;
}
